import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from '../ui/Button';
import { Reveal } from '../ui/Reveal';
interface CtaConfig {
  label: string;
  to?: string;
  href?: string;
  newTab?: boolean;
  icon?: React.ReactNode;
  onClick?: () => void;
}
interface CtaBandProps {
  title: string;
  subtitle: string;
  primaryCta: CtaConfig;
  secondaryCta?: CtaConfig;
}
export const CtaBand = ({
  title,
  subtitle,
  primaryCta,
  secondaryCta
}: CtaBandProps) => <section className="py-20" data-id="element-1126" data-mp="1b1gojccb3yab">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1127" data-mp="1b0nrx472ap5w">
      <Reveal data-id="element-1128" data-mp="1fsozictabrpl">
        <div className="bg-zano-charcoal rounded-3xl p-10 md:p-16 text-center text-white relative overflow-hidden" data-id="element-1129" data-mp="1fu042euk13hr">
          <div className="absolute top-0 right-0 w-64 h-64 bg-zano-pink/20 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-1130" data-mp="1krifqczyhwtg" />
          <div className="absolute bottom-0 left-0 w-64 h-64 bg-zano-lavender/10 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2" data-id="element-1131" data-mp="1ppblx619eqtq" />
          <div className="relative z-10 max-w-2xl mx-auto" data-id="element-1132" data-mp="290bw9nqtg7jp">
            <h2 className="text-3xl md:text-4xl font-bold mb-5" data-id="element-1133" data-mp="240z18fpsju61">{title}</h2>
            <p className="text-lg text-gray-300 mb-8" data-id="element-1134" data-mp="23zo0korn72j5">{subtitle}</p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-1135" data-mp="1z2xhdskjjqti">
              {/* Secondary on the left */}
              {secondaryCta && (secondaryCta.href ? <a href={secondaryCta.href} target={secondaryCta.newTab ? '_blank' : undefined} rel={secondaryCta.newTab ? 'noopener noreferrer' : undefined} className="w-full sm:w-auto" data-id="element-1136" data-mp="2rp8kb9vme3th">
                    <Button variant="secondary" className="bg-transparent text-white border-gray-600 hover:bg-gray-800 hover:border-gray-500 w-full sm:w-auto px-8 py-3" data-id="element-1137" data-mp="2czt4uq1jhkt3">
                      {secondaryCta.icon}
                      {secondaryCta.label}
                    </Button>
                  </a> : secondaryCta.to ? <Link to={secondaryCta.to} className="w-full sm:w-auto" data-id="element-1138" data-mp="u2zb8k1xzg1x">
                    <Button variant="secondary" className="bg-transparent text-white border-gray-600 hover:bg-gray-800 hover:border-gray-500 w-full sm:w-auto px-8 py-3" data-id="element-1139" data-mp="u0v8i5fs4n38">
                      {secondaryCta.icon}
                      {secondaryCta.label}
                    </Button>
                  </Link> : <Button variant="secondary" onClick={secondaryCta.onClick} className="bg-transparent text-white border-gray-600 hover:bg-gray-800 hover:border-gray-500 w-full sm:w-auto px-8 py-3" data-id="element-1140" data-mp="b5y2co59ovsp">
                    {secondaryCta.icon}
                    {secondaryCta.label}
                  </Button>)}
              {/* Primary on the right */}
              {primaryCta.to ? <Link to={primaryCta.to} className="w-full sm:w-auto" data-id="element-1141" data-mp="3q1hw6bv1ode8">
                  <Button variant="primary" className="bg-white text-zano-charcoal hover:bg-gray-100 w-full sm:w-auto px-8 py-3" data-id="element-1142" data-mp="8jxdh25dtd82">
                    {primaryCta.label}{' '}
                    <ArrowRight size={18} className="ml-1.5" data-id="element-1143" data-mp="hiskuhk5wtcy" />
                  </Button>
                </Link> : <Button variant="primary" onClick={primaryCta.onClick} className="bg-white text-zano-charcoal hover:bg-gray-100 w-full sm:w-auto px-8 py-3" data-id="element-1144" data-mp="cnmwzd7794m8">
                  {primaryCta.label} <ArrowRight size={18} className="ml-1.5" data-id="element-1145" data-mp="2taxtr8c25uop" />
                </Button>}
            </div>
          </div>
        </div>
      </Reveal>
    </div>
  </section>;